<template>
    <div>
        <Card>
            <template #title>
                Contratos
            </template>
            <template #content>

                <Toolbar class="mb-2 bg-gray-100">
                    <template #start>
                        <div class="flex items-center gap-1">
                            <Button icon="pi pi-file-excel" label="Download" severity="success" size="small"
                                    @click="downloadData" />
                            <Button v-if="permissoes.CONTRATO_INCLUIR" icon="pi pi-cloud-upload" label="Upload" severity="info" size="small"
                                    @click="openUploadForm" />
                        </div>
                    </template>
                    <template #end>
                        <div class="flex items-center gap-1">
                            <Button v-if="permissoes.CONTRATO_INCLUIR" icon="pi pi-plus" label="Incluir" severity="info" size="small"
                                @click="openForm({})" />
                            <Button icon="pi pi-search" label="Buscar" severity="sucess" size="small"
                                @click="toggleBusca" />
                            <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small"
                                @click="loadData" />
                            <Button :disabled="!selectedRows.length" icon="pi pi-check-square" label="Multiplos" severity="help" size="small"
                                aria-haspopup="true" aria-controls="option_menu"
                                @click="toggleOptions" />
                            <Menu ref="options" id="option_menu" :model="items" :popup="true" />
                        </div>
                    </template>
                </Toolbar>

                <DataTable :value="lista" :loading="isLoading" size="small" stripedRows showGridlines scrollable
                    scrollHeight="calc(100vh - 300px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
                    v-model:selection="selectedRows"
                    @sort="onTableSort">

                    <Column style="width: 100px" field="id" header="#" sortable></Column>
                    <Column field="id_primario" header="ID Primario" sortable></Column>
                    <Column field="id_secundario" header="ID Secundario" sortable></Column>
                    <Column field="cliente" header="Cliente" sortable></Column>
                    <Column field="site" header="Site/Localidade" sortable></Column>
                    <Column field="cidade" header="Cidade" sortable>
                        <template #body="{ data }">
                            {{ data.cidade }}
                            <template v-if="data.estado_id">
                                ({{data.uf}})
                            </template>
                        </template>
                    </Column>
                    <Column field="responsavel" header="Responsável" sortable></Column>
                    <Column field="etapa" header="Etapa" sortable>
                        <template #body="{ data }">
                            {{ data.etapa_descricao || data.etapa }}
                        </template>
                    </Column>

                    <Column style="width: 120px" bodyClass="flex justify-content-end gap-1">
                        <template #body="{ data }">
                            <Badge v-if="data.pendencias" :value="data.pendencias" severity="warn"></Badge>
                            <Button icon="pi pi-pen-to-square" title="Atualizar" severity="info" size="small"
                                @click="openForm(data)" />
                            <Button v-if="permissoes.CONTRATO_REMOVER" icon="pi pi-trash" title="Remover" severity="danger" size="small"
                                @click="remove(data)" />
                        </template>
                    </Column>
                    <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                    <template #empty>
                        <div class="text-center text-gray-600">
                            Nenhum registro encontrado
                        </div>
                    </template>
                </DataTable>

                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center">
                        <div class="flex justify-end mt-2 text-sm text-gray-600">
                            <span>{{ pagination.total }} registros</span>
                        </div>

                    </div>
                    <div class="flex align-items-center justify-content-center">
                        <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                            @page="onPage">
                        </Paginator>
                    </div>
                    <div class="flex align-items-center justify-content-center">
                    </div>
                </div>

            </template>
        </Card>
        <ContratoForm :visible="visibleForm" :id="item.id || 0" :data="item" :permissoes="permissoes" @close="closeForm" @save="loadData" />
        <UploadForm :visible="visibleUploadForm" :permissoes="permissoes" @close="closeForm" @save="loadData" />
        <ResponsavelForm :visible="visibleResponsavelForm" :contratos="selectedRows" @close="visibleResponsavelForm=false" @save="loadData" />
        <Popover ref="busca" :closeOnEscape="false" :dismissable="false" class="w-3">
            <div class="w-full">
                <form @submit.prevent="onSubmitBusca">
                    <div class="w-full">
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText v-model="params.filter['contrato']" class="w-full" />
                                <label>ID Primário e Secundário</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <MultiSelect v-model="params.filter['con.solicitante_id']" display="chip" :maxSelectedLabels="6"
                                    :options="solicitanteOpt" optionLabel="descricao" filter
                                    class="w-full" optionValue="id" />
                                <label>Solicitante</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText v-model="params.filter['cli.nome']" class="w-full" />
                                <label>Cliente</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText v-model="params.filter['site']" class="w-full" />
                                <label>Site/Localidade</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <Select v-model="params.filter['con.estado_id']" :options="estadoOpt"
                                    optionLabel="nome" filter @change="onEstadoChange"
                                    class="w-full" optionValue="id" />
                                <label>Estado</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <MultiSelect v-model="params.filter['con.cidade_id']" display="chip" :maxSelectedLabels="6"
                                    :options="cidadeOpt" optionLabel="nome" filter
                                    class="w-full" optionValue="id" />
                                <label>Cidade</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <MultiSelect v-model="params.filter['con.etapa']" display="chip" :maxSelectedLabels="6"
                                    :options="etapaOpt" optionLabel="descricao" filter
                                    class="w-full" optionValue="id" />
                                <label>Etapa</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <MultiSelect v-model="params.filter['responsavel_id']" display="chip" :maxSelectedLabels="6"
                                    :options="responsavelOpt" optionLabel="nome" filter
                                    class="w-full" optionValue="id" />
                                <label>Responsável</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <Select v-model="params.filter['fechamento']" :options="[{id: 1, 'descricao': 'Aguardando Fechamento'}]"
                                    optionLabel="descricao" filter showClear
                                    class="w-full" optionValue="id" />
                                <label>Fechamento</label>
                            </FloatLabel>
                        </div>
                    </div>

                    <div class="flex justify-content-end gap-1">
                        <Button type="submit" label="Buscar" severity="success" icon="pi pi-search"
                            class="flex align-items-center justify-content-center" />
                        <Button icon="pi pi-eraser" label="Limpar" severity="warn" size="small"
                            class="flex align-items-center justify-content-center" @click="onClearBusca" />
                        <Button icon="pi pi-times" label="Fechar" severity="danger" size="small"
                            class="flex align-items-center justify-content-center" @click="toggleBusca" />
                    </div>
                </form>
            </div>
        </Popover>
    </div>
</template>
<script>
import Card from 'primevue/card';
import Badge from 'primevue/badge';
import Menu from 'primevue/menu';

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';
import MultiSelect from 'primevue/multiselect';
import Select from 'primevue/select';

import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';

import ContratoForm from '@/page/contrato/Form.vue';
import UploadForm from '@/page/contrato/UploadForm.vue';
import ResponsavelForm from '@/page/contrato/ResponsavelForm.vue';

import Contrato from '@/service/contrato.js';
import Estado from '@/service/estado.js';
import Cidade from '@/service/cidade.js';
import Solicitante from '@/service/solicitante.js';
import Etapa from '@/service/etapa.js';
import Usuario from '@/service/usuario.js';

import File from '@/utils/File.js';
import Filter from '@/utils/Filter.js';

import Moment from 'moment';

export default {
    components: {
        Card,
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,
        MultiSelect,
        Select,
        Badge,
        Menu,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,

        /* Form */
        ContratoForm,
        UploadForm,
        ResponsavelForm,
    },
    data() {
        return {
            isLoading: false,
            lista: [],
            item: {},
            visibleForm: false,
            visibleUploadForm: false,
            visibleResponsavelForm: false,

            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: -1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },
            permissoes: permissoes,

            solicitanteOpt: [],
            isLoadingSolicitanteOpt: false,

            etapaOpt: [],
            isLoadingEtapaOpt: false,

            estadoOpt: [],
            isLoadingEstadoOpt: false,

            cidadeOpt: [],
            isLoadingCidadeOpt: false,

            responsavelOpt: [],
            isLoadingResponavelOpt: false,

            selectedRows: [],
            items: [
                    {
                        label: 'Opções:',
                        items: [
                            {
                                label: 'Responsável',
                                icon: 'pi pi-user',
                                command: (event, data) => {
                                    this.visibleResponsavelForm = true;
                                }
                            },
                            {
                                label: 'Para Cotação',
                                icon: 'pi pi-arrow-right',
                                command: (event, data) => {
                                    this.$confirm.require({
                                        message: 'Deseja realmente mover os contratos de LEAD para Cotação?',
                                        header: 'Para Cotação',
                                        acceptLabel: 'Mover',
                                        icon: 'pi pi-arrow-right',
                                        acceptClass: 'bg-success-500 text-white',
                                        rejectLabel: 'Cancelar',
                                        rejectClass: 'bg-red-500 text-white border-red-500',
                                        accept: () => {
                                            const form = {};
                                            const contratos = [];
                                            this.selectedRows.forEach(contrato => {
                                                contratos.push(contrato.id);
                                            });
                                            form.contratos = contratos;

                                            this.isLoading = true;
                                            Contrato.updateCotacao(form)
                                                .then(response => {
                                                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Os contratos foram atualizados com sucesso.', life: 3000 });
                                                    this.loadData();
                                                })
                                                .catch(error => {
                                                    if (error.response) {
                                                        if (error.response.data.msg) {
                                                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                                            return;
                                                        }
                                                    }
                                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                                                })
                                                .finally(() => {
                                                    this.isLoading = false;
                                                });
                                        },
                                    });
                                }
                            }
                        ]
                    }],
        }
    },
    beforeMount() {
        document.addEventListener("onPermissios", event => this.permissoes = event.permissoes);
    },
    mounted() {
        this.loadEstadoOpt();
        this.loadSolicitanteOpt();
        this.loadEtapaOpt();
        this.loadUsuarioOpt();

        this.loadData();
    },
    methods: {
        openUploadForm() {
            this.visibleUploadForm = true;
        },
        dateFormat(value) {
            if (!value) return;
            return Moment(value).format("DD/MM/YYYY HH:mm");
        },
        openForm(item) {
            this.item = { ...item };
            this.visibleForm = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;
            this.visibleUploadForm = false;
        },
        remove(data) {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Contrato.delete(data.id)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            this.loadData();
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;
                                if (err.erros) {
                                    for (let i in err.erros) {
                                        this.errors[i] = err.erros[i][0];
                                    }
                                    return;
                                }
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
        loadDataParams(usePage = true) {
            let params = [];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            return params;
        },
        downloadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Contrato.download(params.join("&"))
                .then(response => {
                    File.downloadBlob(response);
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        loadData() {
            let params = this.loadDataParams();

            this.selectedRows = [];
            this.isLoading = true;
            Contrato.list(params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        toggleOptions(event) {
            this.$refs.options.toggle(event);
        },

        // Filter
        toggleBusca(event) {
            this.$refs.busca.toggle(event);
        },
        onClearBusca(event) {
            this.toggleBusca(event);
            this.params.filter = {};
            this.onPage();
        },
        onSubmitBusca(event) {
            this.toggleBusca(event);
            this.onPage();
        },


        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.$router.replace({ name: this.$route.name, query: { page: page } });
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        },

        onEstadoChange(event) {
            this.params.filter['con.cidade_id'] = null;
            if(event.value) {
                this.loadCidadeOpt(event.value);
            }
        },
        loadEstadoOpt() {
            this.isLoadingEstadoOpt = true;
            Estado.option(['order[descricao]=asc'].join("&"))
                .then(response => {
                    this.estadoOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingEstadoOpt = false;
                });
        },
        loadCidadeOpt(estadoId) {
            if(!estadoId) {
                this.cidadeOpt = [];
                return;
            }

            this.isLoadingCidadeOpt = true;
            Cidade.option(estadoId, ['order[nome]=asc'].join("&"))
                .then(response => {
                    this.cidadeOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingCidadeOpt = false;
                });
        },
        loadUsuarioOpt() {

            this.isLoadingResponavelOpt = true;
            Usuario.option(['order[nome]=asc'].join("&"))
                .then(response => {
                    let responsaveis    = [{ id: 0, nome: "[SEM RESPONSAVEL]" }];
                    this.responsavelOpt = responsaveis.concat(response.data);
                })
                .finally(() => {
                    this.isLoadingResponavelOpt = false;
                });
        },
        loadEtapaOpt() {
            this.isLoadingEtapaOpt = true;
            Etapa.option(['order[ordem]=asc'].join("&"))
                .then(response => {
                    this.etapaOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingEtapaOpt = false;
                });
        },
        loadSolicitanteOpt() {
            this.isLoadingSolicitanteOpt = true;
            Solicitante.option(['order[descricao]=asc'].join("&"))
                .then(response => {
                    this.solicitanteOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingSolicitanteOpt = false;
                });
        },
    }
}
</script>
